import { render, staticRenderFns } from "./ProductFaqs.vue?vue&type=template&id=63692f26&"
import script from "./ProductFaqs.vue?vue&type=script&lang=js&"
export * from "./ProductFaqs.vue?vue&type=script&lang=js&"
import style0 from "./ProductFaqs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports